export enum RangeDefActionTypes {
    API_RESPONSE_SUCCESS = '@@rangeDef/API_RESPONSE_SUCCESS',
    API_RESPONSE_ERROR = '@@rangeDef/API_RESPONSE_ERROR',

    ADD_RANGE_DEF = '@@rangeDef/ADD_RANGE_DEF',
    EDIT_RANGE_DEF = '@@rangeDef/EDIT_RANGE_DEF',
    GET_RANGE_DEFS = '@@rangeDef/GET_RANGE_DEFS',
    GET_RANGE_DEF = '@@rangeDef/GET_RANGE_DEF',
    RESET = '@@rangeDef/RESET',
    RESET_SUCCESS = '@@rangeDef/RESET_SUCCESS',
    RESET_ERROR = '@@rangeDef/RESET_ERROR',
}
